export const getBrowserTimezoneName = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.warn("[getBrowserTimezoneName] Error getting browser timezone:", error);
    return "UTC";
  }
};

export const getTimezoneFromUserOrBrowser = (user?: { timezone?: { name?: string } }): string => {
  if (user?.timezone?.name) {
    return user.timezone.name;
  }

  return getBrowserTimezoneName();
};
